import React from 'react'
import Header from 'pages/header/index1'
import Footer from 'pages/footer'
import useStyles from './style'
import { useSelector } from 'react-redux'

const HomeLayout = (props) => {
  const { children } = props
  const classes = useStyles()
  const menuDrawer = useSelector(
    (state) => state?.MenuToggleReducer?.menuDrawer
  )

  return (
    <>
      <section className={menuDrawer ? classes.layout : {}}>
        <Header />
        <section className={classes.children}>{children}</section>
        <Footer contactVisible={props?.contactVisible} />
      </section>
    </>
  )
}

export default HomeLayout
